interface ViewControlsProps {
  /** 기준 시점으로 리셋(모델 화면맞춤 + 정북 3/4) */
  onHome: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  className?: string;
}

const BTN =
  "flex h-9 w-9 items-center justify-center leading-none text-slate-600 transition hover:bg-black/5 hover:text-slate-900";

/**
 * 카메라 보조 컨트롤 — 홈(기준 시점) + 줌. 회전/틸트는 마우스 드래그·축 기즈모가 담당.
 * (라이트 글래스로 다른 패널과 통일)
 */
export function ViewControls({ onHome, onZoomIn, onZoomOut, className = "" }: ViewControlsProps) {
  return (
    <div
      className={`flex flex-col overflow-hidden rounded-xl border border-black/5 bg-white/85 shadow-lg backdrop-blur-md ${className}`}
    >
      <button
        type="button"
        aria-label="기준 시점"
        title="기준 시점"
        onClick={onHome}
        className={BTN}
      >
        <svg
          viewBox="0 0 24 24"
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M3 11.5 12 4l9 7.5" />
          <path d="M5 10v9h14v-9" />
        </svg>
      </button>
      <div className="h-px bg-black/10" />
      <button
        type="button"
        aria-label="확대"
        title="확대"
        onClick={onZoomIn}
        className={`${BTN} text-xl`}
      >
        +
      </button>
      <button
        type="button"
        aria-label="축소"
        title="축소"
        onClick={onZoomOut}
        className={`${BTN} text-2xl`}
      >
        −
      </button>
    </div>
  );
}
